import { ServiceResponse } from '@sdbn/appclient';
import { CompleteTransportAssignment, TransportCompletionOption } from './../model/transport-completion-option';
import { TaskRelevance } from './../model/task-relevance.enum';
import { TaskAssignmentOptions } from './../model/task-assignment-options';
import { ResponseMessage } from '@sdbn/appclient';
import { TaskPosition } from './../model/task-position';
import { Identity } from '@sdbn/appclient';
import { DialogLayout } from 'src/app/shared/dialog-layout/dialog-layout';
import { TaskAssignmentDialogComponent } from './../component/task-assignment-dialog.component';
import { environment } from 'src/environments/environment';
import { Task } from './../model/task';
import { HttpService } from '@sdbn/appclient';
import { Injectable } from '@angular/core';
import { Observable, AsyncSubject } from 'rxjs';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { HttpHeaders } from '@angular/common/http';
import { TaskCompletion } from '../model/task-completion';
import { DocumentTaskUpdate } from '../model/document-task-update';

@Injectable({
  providedIn: 'root'
})
export class TaskAssignmentService {

  constructor(
    private httpService: HttpService,
    private dialog: MatDialog
  ) { }

  public openAssignmentDialog(editTasks: Task[], processingStatusModel: string) {

    const subject = new AsyncSubject<Task[]>();

    this.loadTaskAssignmentOptions().subscribe(
      result => {

        // restore selection and options based on editableTasks
        for (const t of result.tasks) {
          if (editTasks != null) {
            const editableTask = editTasks.filter(et => et.id === t.id);
            if (editableTask.length === 1) {
              t.selected = true;

              for (const key of Object.keys(TaskRelevance)) {
                const rel = TaskRelevance[key];
                if (rel === editableTask[0].relevance) {
                  t.relevance = rel;
                }
              }

              t.processingStatus = editableTask[0].processingStatus;
            }
          }
        }

        this.dialog.open(TaskAssignmentDialogComponent, {
          data: { taskAssignmentOptions: result, processingStatusModel },
          panelClass: DialogLayout.panelClass
        }).afterClosed().subscribe(
          dialogResult => {
            subject.next(dialogResult);
            subject.complete();
          }
        );
      }, error => {
        console.log('Error Loading tasks', error);
        subject.error(error);
      }
    );

    return subject;
  }

  public completeDocumentTask(transportId: number, taskId: number, type: string, name: string, content: any): AsyncSubject<void> {

    const subject = new AsyncSubject<void>();

    this.httpService.postFile(`${environment.taskEndpoint}/complete-picture-task`, content, new HttpHeaders({
      'Content-Type': type,
      'Content-MD5': 'test', // TODO: Calculate MD5 hash of capture.blob
      transportId: transportId + '',
      taskId: taskId + '',
      filename: encodeURIComponent(name)
    })).toPromise().then(response => {
      subject.next();
      subject.complete();
    }, error => {
      console.log('completeDocumentTask call failed:', error);
      subject.error(error);
    });

    return subject;
  }

  private loadTaskAssignmentOptions(): Observable<TaskAssignmentOptions> {
    return this.httpService.postWithContext<TaskAssignmentOptions>(environment.taskEndpoint, {});
  }

  public loadPositionTasks(transport: Identity): Observable<TaskPosition[]> {
    return this.httpService.postWithContext<TaskPosition[]>(environment.taskEndpoint + '/positions', transport);
  }

  public completeTask(completion: TaskCompletion): Observable<ResponseMessage[]> {
    return this.httpService.postWithContext<ResponseMessage[]>(environment.taskEndpoint + '/complete-transport-task', completion);
  }

  public updateDocumentTask(completion: DocumentTaskUpdate): Observable<ResponseMessage[]> {
    return this.httpService.postWithContext<ResponseMessage[]>(environment.taskEndpoint + '/update-document-task', completion);
  }

  public getTransportCompletionOption(transport: Identity): Observable<TransportCompletionOption> {
    return this.httpService.postWithContext<TransportCompletionOption>(environment.taskEndpoint + '/completion-option', transport);
  }

  public completeTransportAssignment(completeTransportAssignment: CompleteTransportAssignment): Observable<ServiceResponse> {
    return this.httpService.postWithContext<ServiceResponse>(environment.taskEndpoint + '/complete-transport-assignment', completeTransportAssignment);
  }
}
